import { Atom, PrimitiveAtom, useAtomValue } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

type BaseState = {
  isOpen: boolean;
};

export const useSwapDrawer = <State extends BaseState>(
  atom: PrimitiveAtom<State> | Atom<State>,
  monitoringPropertyName: keyof State | Array<keyof State>,
) => {
  const state = useAtomValue(atom);
  const monitoringProperty = Array.isArray(monitoringPropertyName)
    ? monitoringPropertyName.map((name) => state[name])
    : [state[monitoringPropertyName]];
  const [currentProps, setCurrentProps] = useState<State>(state);

  const handleTransitionEnd = useCallback(() => {
    setCurrentProps(state);
  }, [state]);

  useEffect(() => {
    setCurrentProps((_state) => ({
      ..._state,
      isOpen: false,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, monitoringProperty);

  useEffect(() => {
    if (state.isOpen) {
      setCurrentProps(state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isOpen]);

  return {
    state: currentProps,
    handleTransitionEnd,
  };
};
